import React from 'react';
import { Mail, Phone, CalendarDays, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{ backgroundColor: 'var(--bg-page)', borderTop: '1px solid var(--border-light)' }}>
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Logo and Company Info */}
          <div className="md:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_loveyuh-bizhelp/artifacts/agf3ac47_FullColor_BlackBackground1280x1024_72dpi.png" 
              alt="LOVEYUHLIFE - Web Development and Consulting Services Company Logo"
              className="h-20 w-auto mb-4"
              width="120"
              height="80"
              loading="lazy"
            />
            <p className="body-small max-w-md" style={{ color: 'var(--text-secondary)' }}>
              An emerging web development company specializing in comprehensive digital solutions for small businesses. 
              From logo design to project management, we elevate your business through innovative technology.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="heading-6 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="link-text hover:opacity-80 transition-opacity">
                  Our Services
                </a>
              </li>
              <li>
                <a href="#testimonials" className="link-text hover:opacity-80 transition-opacity">
                  Client Reviews
                </a>
              </li>
              <li>
                <a href="#contact" className="link-text hover:opacity-80 transition-opacity">
                  Get In Touch
                </a>
              </li>
            </ul>
          </div>
          
          {/* Services */}
          <div>
            <h4 className="heading-6 mb-4">Services</h4>
            <ul className="space-y-2">
              <li className="body-small" style={{ color: 'var(--text-secondary)' }}>Logo Design</li>
              <li className="body-small" style={{ color: 'var(--text-secondary)' }}>Website Development</li>
              <li className="body-small" style={{ color: 'var(--text-secondary)' }}>Monitoring & Analytics</li>
              <li className="body-small" style={{ color: 'var(--text-secondary)' }}>Project Management</li>
            </ul>
          </div>
        </div>
        
        {/* Contact Info and Copyright */}
        <div className="pt-8 border-t" style={{ borderColor: 'var(--border-light)' }}>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Contact Icons */}
            <div className="flex items-center gap-6">
              <a 
                href="mailto:admin@loveyuhlife.ca" 
                className="flex items-center gap-2 link-text hover:opacity-80 transition-opacity"
              >
                <Mail size={20} />
                <span className="hidden sm:inline">admin@loveyuhlife.ca</span>
              </a>
              
              <a 
                href="tel:4165618684" 
                className="flex items-center gap-2 link-text hover:opacity-80 transition-opacity"
              >
                <Phone size={20} />
                <span className="hidden sm:inline">416 561 8684</span>
              </a>
              
              <a 
                href="#contact" 
                className="flex items-center gap-2 link-text hover:opacity-80 transition-opacity"
              >
                <CalendarDays size={20} />
                <span className="hidden sm:inline">Schedule Meeting</span>
              </a>
              
              <a 
                href="https://www.instagram.com/loveyuhlife" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:opacity-80 transition-opacity"
                style={{ color: 'var(--brand-primary)' }}
              >
                <Instagram size={20} />
                <span className="hidden sm:inline">Follow Us</span>
              </a>
            </div>
            
            {/* Copyright */}
            <p className="caption text-center md:text-right" style={{ color: 'var(--text-secondary)' }}>
              © 2021, LOVEYUHLIFE INC. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;